<template>
    <div>
        <section class="page-title page-title-layout3 text-center bg-overlay bg-parallax bg-menuImage" v-bind:style="{ backgroundImage: 'url(' + menu.menuImage + ')' }">
            <router-link :to="`/`">
                <font-awesome-icon icon="arrow-circle-left" id="goBack"/>
            </router-link>
            <div class="bg-img"></div>
            <div class="container">
                <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-10 offset-lg-1">
                    <img id="logoImage" v-bind:src=menu.businessLogo>
                </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'MenuHeader',
    props: ['menu']
}
</script>


<style>
 .bg-img {
    position: relative;
    z-index: 1;
  }
  .bg-menuImage{
    background-size: cover;
    background-position: center center;
  }
  .bg-overlay:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(27, 26, 26, 0.45);

  }
  .bg-overlay-gradient:before {
    background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.75)), to(rgba(0, 0, 0, 0.03)));
    background-image: -webkit-linear-gradient(center bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.03));
    background-image: -moz-linear-gradient(center bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.03));
    background-image: -ms-linear-gradient(center bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.03));
    background-image: -o-linear-gradient(center bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.03));
    background-image: linear-gradient(center bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.03));
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="rgba(0,0,0,0.75)", endColorstr="rgba(0,0,0,0.03)", GradientType=1);
}
  .bg-parallax {
    background-attachment: fixed;
  }
  .page-title {
    padding-top: 283px;
    padding-bottom: 30px;
  }
  .page-title-layout3 {
    padding-top: 287px;
    padding-bottom: 187px;
  }
  #logoImage{
      width: 300px;
  }
  #logoImageHome {
       width: 150px;
  }
  #goBack {
    position: absolute;
    left: 10px;
    top: 15px;
    font-size: 30px;
  }
  .bg-homeImage {
      background-image: url("../../assets/images/empanadillas.jpeg")
  }
</style>